export const TEAMS = [
    { id: "RED",    color: { r: 255, g: 100, b: 100 } },
    { id: "BLUE",   color: { r: 100, g: 150, b: 255 } },
    { id: "GREEN",  color: { r: 100, g: 255, b: 100 } },
    { id: "YELLOW", color: { r: 255, g: 255, b: 100 } },
    { id: "PURPLE", color: { r: 200, g: 100, b: 255 } },
    { id: "ORANGE", color: { r: 255, g: 165, b: 0   } }
];